<NavBar screenTitle="Depth Chart"/>
<div class="columns is-marginless dc-scroll">
    {#each positions as position, idx}
    <div class="column is-4 dc-block">
        <nav class='panel'>
            <div class='panel-heading has-background-primary has-text-white'>
                {positionNames[idx]}
                <span class='icon is-pulled-right edit-inning' on:click='set({selectedPosNum: position, dcEditorOpen: true})'>
                    <i class='fas fa-cog'></i>
                </span>
            </div>
            <p class='panel-block'>
                <span class='panel-icon lineup-id'>1 </span>
                {#if $depthChart[position] && $depthChart[position][0].last}{$depthChart[position][0].last}{:else}&nbsp;{/if}
            </p>
            <p class='panel-block'>
                <span class='panel-icon lineup-id'>2</span>
                {#if $depthChart[position] && $depthChart[position][1].last}{$depthChart[position][1].last}{:else}&nbsp;{/if}
            </p>
            <p class='panel-block'>
                <span class='panel-icon lineup-id'>3</span>
                {#if $depthChart[position] && $depthChart[position][2].last}{$depthChart[position][2].last}{:else}&nbsp;{/if}
            </p>
            <p class='panel-block'>
                <span class='panel-icon lineup-id'>4</span>
                {#if $depthChart[position] && $depthChart[position][3].last}{$depthChart[position][3].last}{:else}&nbsp;{/if}
            </p>
            <p class='panel-block'>
                <span class='panel-icon lineup-id'>5</span>
                {#if $depthChart[position] && $depthChart[position][4].last}{$depthChart[position][4].last}{:else}&nbsp;{/if}
            </p>
        </nav>
    </div>
    {/each}
</div>

<DepthChartEditor bind:active=dcEditorOpen bind:chart=selectedChart bind:posNum=selectedPosNum positionName={positionNames[selectedPosNum-1]}/>

<script>
    import NavBar from './NavBar.html';
    import DepthChartEditor from './DepthChartEditor.html';

    export default {
        data() {
            return {
                currentPosNum: 0,
                dcEditorOpen: false,
                selectedPosNum: 1
            };
        },
        computed: {
            selectedChart: ({ selectedPosNum, $depthChart }) => $depthChart[selectedPosNum],
            positions: ({$hasExtraFielder}) => {
                let positions = [1, 2, 3, 4, 5, 6, 7, 8, 9];

                if($hasExtraFielder) {
                    positions.push(10);
                }
                return positions;
            },
            positionNames: ({$hasExtraFielder}) => {
                let positionNames = [
                    "Pitcher",
                    "Catcher",
                    "1st Base",
                    "2nd Base",
                    "3rd Base",
                    "Shortstop",
                    "Left Field",
                    "Center Field",
                    "Right Field"
                ];

                if($hasExtraFielder) {
                    positionNames[7] = "Left Center";
                    positionNames.push('Right Center');
                }
                return positionNames;
            }

        },
        methods: {

        },
        components: {
            NavBar,
            DepthChartEditor
        }
    };
</script>

<style>
    .panel-block {
        padding: 0.4em 0.75em;
    }
    .dc-scroll {
        overflow-x: auto;
        scroll-snap-type: x mandatory;
        -webkit-scroll-snap-type: mandatory;
        -webkit-scroll-snap-points-x: repeat(33%);
    }

    .dc-block {
        scroll-snap-align: start;
        -webkit-scroll-snap-align: start;
    }
</style>
